'use strict';

/**
 * Module dependencies
 */
var angular = require('angular');

var ExceptionHandler = require('./ExceptionHandler.js');

var loggerModule = module.exports = angular
  .module('app.core-utilities.firebaseLogger', [])
  .provider('ApplicationLogger', require('./ApplicationLogger.js'));

ExceptionHandler(loggerModule);



// WEBPACK FOOTER //
// ./src/js/core-utilities/firebaseLogger/index.js